import { useRef, useState } from "react";
import Button from "../../../common/Button";
import { useDispatch, useSelector } from "react-redux";
import { notificationActions } from "../../../../store/notifications";
import { uploadRecordsDocumentApi } from "../../../../lib/fetchApi";
import { caseActions } from "../../../../store/case";
import { filterActions } from "../../../../store/filter";
import { validateBoxUploadFile } from "../../../../lib/docs";

export default function RecordsUpload({practiceId, managingAttyId, activeCase, forWorkQ, practiceItem, isUpdate}) {
    const inputRef = useRef(null)
    const dispatch = useDispatch()

    const [loading, setLoading] = useState(false)

    const userToken = useSelector(state => state.user.token)

    const onFileDrop = (e) => {
        if (e.target.files.length > 0) {
            const selectedFile = e.target.files[0]
            const sizeError = validateBoxUploadFile(selectedFile)
            if (sizeError) {
                dispatch(notificationActions.setError({
                    errorMessage: `"${selectedFile.name}" is too large. ${sizeError}`,
                }))
                e.target.value = ''
                return
            }

            let filesArray = [{
                id: Math.random(),
                file: selectedFile.name,
                file_to_upload: selectedFile,
                practices: null,
                procodocs_document_type_id: 'TODO',
                notes: null
            }]


            if(filesArray && filesArray.length) {
                let file = filesArray[0]
                let formData = new FormData();

                formData.append("file", file.file_to_upload);            
                formData.append("practice_id", practiceId)
          

                let reqBody = formData
                saveFileHandler(reqBody)
            }
        }

	}

    async function saveFileHandler(req) {
        setLoading(true)
        const upload = await uploadRecordsDocumentApi(userToken, activeCase.case.id, req, forWorkQ ? null : dispatch)
        if (upload && upload.errorMessage) {
            dispatch(notificationActions.setError(upload))
        } else {
            // /success 
            if (!forWorkQ) {
                if (!managingAttyId) {
                    dispatch(caseActions.pushItemToDDocuments(upload))
                } else {
                    dispatch(caseActions.pushItemToProcoDocuments(upload))
                }
            } else {
                dispatch(filterActions.replaceDocumentInPractices({
                    case_id: activeCase.case.id,
                    case_practice_id: practiceItem.id,
                    newDoc: upload
                }))
            }
        }

         setLoading(false)
    }  

    const openUploadHandler = () => {
        inputRef.current.click()
    }
    return <>
        <input ref={inputRef} type="file" value="" onChange={onFileDrop} name="upload_number_1" id="upload_number_1" style={{display: 'none'}}/>
        {isUpdate ? <Button click={openUploadHandler} isLoading={loading} btnStyle={'btn_small_icon'} title="update records"><i className="ti ti-upload" ></i></Button> 
        : 
        <Button click={openUploadHandler} isLoading={loading} btnStyle={'document_upload'} title="upload records"><i className="ti ti-upload" ></i></Button>}
    </>
}